<template>
  <div class="app-modal-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppModalContainer',
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.app-modal-container {
  background: $White;
  box-shadow: 0px 10px 32px rgba(0, 0, 0, 0.06);
  border-radius: 16px;
  padding: 24px;

  @media (max-width: 576px) {
    padding: 20px;
  }
}
</style>
